/**
 * usePickerDialog — the modal mechanics of the full-screen workshop picker,
 * split out of `WorkshopPicker` so that component holds only the picker itself.
 *
 * The trap is not optional and not inherited. The picker declares
 * `aria-modal` but renders as a SIBLING of the rebook drawer rather than nested
 * inside it, so the drawer's own trap does not cover it. Without this, pressing
 * Browse unmounts the button that had focus, focus falls to `<body>`, and Tab
 * walks straight into the booking page still mounted behind the overlay.
 */
import { useId, useRef } from 'react';

import { useFocusTrap } from '../../../hooks/useFocusTrap';

export function usePickerDialog() {
  const titleId = useId();
  const panelRef = useRef<HTMLDivElement>(null);
  useFocusTrap(panelRef, { autoFocusFirst: true });
  return { titleId, panelRef };
}
